import { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

export type SubHeadingVariants = 'sh1' | 'sh2' | 'sh3';

export const Subheading = ({
  variant,
  className,
  children,
}: {
  variant: SubHeadingVariants;
  className?: string;
  children?: ReactNode;
}) => {
  switch (variant) {
    case 'sh1':
      return <h4 className={twMerge('font-bold', className)}>{children}</h4>;
    case 'sh2':
      return <h5 className={twMerge('font-bold', className)}>{children}</h5>;
    default:
      return <h6 className={twMerge('font-bold', className)}>{children}</h6>;
  }
};
